import { Box, Typography } from "@mui/material";
import servicesBg from "../../images/fundraiser.png";
import servicesWoman from "../../images/women.png";

const HeroFeatureSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fff",
        py: { xs: "48px", md: "72px" },
        px: { xs: "24px", md: "80px" },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box sx={{ maxWidth: "1152px", mx: "auto", position: "relative" }}>
        {/* Heading */}
        <Box sx={{ mb: "40px" }}>
          <Typography
            sx={{
              fontSize: { xs: "32px", md: "40px" },
              fontWeight: 700,
              color: "#111111",
              letterSpacing: "-0.025em",
              mb: "12px",
            }}
          >
            Services
          </Typography>
          <Typography
            sx={{
              fontFamily: "Mulish",
              fontWeight: 400,
              fontSize: { xs: "15px", md: "17px" },
              color: "#737373",
              lineHeight: 1.7,
            }}
          >
            For over two decades, Muzukuru has been a trusted name in funeral
            services, providing compassionate care to families across Zimbabwe.
          </Typography>
        </Box>

        {/* Grid — */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(12, 1fr)" },
            gap: "24px",
            alignItems: "stretch",
          }}
        >
          {/* Card 1 — large image, col-span-8 */}
          <Box
            sx={{
              position: "relative",
              gridColumn: { md: "span 8" },
              minHeight: "208px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 1px 3px rgba(0,0,0,0.10)",
              cursor: "pointer",
              "& img": {
                transition: "transform 0.3s",
              },
              "&:hover img": {
                transform: "scale(1.02)",
              },
            }}
          >
            <Box
              component="img"
              src={servicesBg}
              alt="Fundraise & Crowdfunding"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "brightness(0.85)",
                display: "block",
              }}
            />
            {/* gradient overlay */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0.2), transparent)",
              }}
            />
            {/* text content */}
            <Box
              sx={{
                position: "absolute",
                bottom: "24px",
                left: "24px",
              }}
            >
              <Box sx={{ color: "#fff", mb: "8px" }}>
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
              </Box>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "20px",
                  letterSpacing: "-0.025em",
                  lineHeight: "1.4",
                }}
              >
                Fundraise &<br />
                Crowdfunding
              </Typography>
            </Box>
          </Box>

          {/* Card 2 — cream, col-span-4 */}
          <Box
            sx={{
              gridColumn: { md: "span 4" },
              bgcolor: "#FDF2E9",
              borderRadius: "16px",
              p: "32px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              minHeight: "208px",
            }}
          >
            <Box sx={{ color: "#614438", mb: "8px" }}>
              <svg
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </Box>
            <Typography
              sx={{
                color: "#614438",
                fontWeight: 700,
                fontSize: "20px",
                letterSpacing: "-0.025em",
                lineHeight: "1.4",
              }}
            >
              Memorials &<br />
              Celebrations
            </Typography>
          </Box>

          {/* Card 3 — cream, col-span-4 */}
          <Box
            sx={{
              gridColumn: { md: "span 4" },
              bgcolor: "#FDF2E9",
              borderRadius: "16px",
              p: "32px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              minHeight: "208px",
            }}
          >
            <Box sx={{ color: "#614438", mb: "8px" }}>
              <svg
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
            </Box>
            <Typography
              sx={{
                color: "#614438",
                fontWeight: 700,
                fontSize: "20px",
                letterSpacing: "-0.025em",
                lineHeight: "1.4",
              }}
            >
              Memorials &<br />
              Celebrations
            </Typography>
          </Box>

          {/* Card 4 — gradient + woman image, col-span-8 */}
          <Box
            sx={{
              position: "relative",
              gridColumn: { md: "span 8" },
              background:
                "linear-gradient(135deg, #5C3423 0%, #9E715C 60%, #B5856F 100%)",
              borderRadius: "16px",
              p: "32px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              minHeight: "208px",
              overflow: "visible",
              zIndex: 10,
            }}
          >
            {/* text */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                height: "100%",
                zIndex: 10,
              }}
            >
              <Box sx={{ color: "#fff", mb: "8px" }}>
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                  />
                </svg>
              </Box>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "20px",
                  letterSpacing: "-0.025em",
                  lineHeight: "1.4",
                }}
              >
                Fundraise &<br />
                Crowdfunding
              </Typography>
            </Box>

            {/* Woman image — absolute bottom-right */}
            <Box
              sx={{
                position: "absolute",
                right: "24px",
                bottom: 0,
                width: "240px",
                height: "340px",
                zIndex: 40,
                pointerEvents: "none",
              }}
            >
              <Box
                component="img"
                src={servicesWoman}
                alt=""
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  objectPosition: "bottom",
                  display: "block",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroFeatureSection;
